var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchUsersLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M24.478,28.468 C21.434,28.468 18.957,25.991 18.957,22.946 C18.957,19.902 21.434,17.425 24.478,17.425 C27.523,17.425 30,19.902 30,22.946 C30,25.991 27.523,28.468 24.478,28.468 L24.478,28.468 Z M7.521,28.468 C4.477,28.468 2,25.991 2,22.946 C2,19.902 4.477,17.425 7.521,17.425 C10.566,17.425 13.043,19.902 13.043,22.946 C13.043,25.991 10.566,28.468 7.521,28.468 L7.521,28.468 Z M26.702,9.509 C26.652,9.392 26.58,9.285 26.49,9.196 L24.685,7.39 L22.804,2.455 C22.746,2.301 22.65,2.165 22.527,2.057 C21.036,0.756 18.789,0.756 17.299,2.057 C17.082,2.247 16.957,2.522 16.957,2.811 L16.957,7.946 C16.957,8.498 17.404,8.946 17.957,8.946 C18.509,8.946 18.957,8.498 18.957,7.946 L18.957,3.324 C19.605,2.968 20.416,3.001 21.034,3.426 L22.892,8.302 C22.942,8.434 23.02,8.553 23.119,8.653 L24.939,10.473 L27.299,15.978 C26.427,15.624 25.476,15.425 24.478,15.425 C22.295,15.425 20.332,16.365 18.957,17.856 L18.957,12.096 C19.762,12.436 20.217,12.864 20.217,13.164 C20.217,13.716 20.665,14.164 21.217,14.164 C21.77,14.164 22.217,13.716 22.217,13.164 C22.217,11.106 19.544,9.555 16,9.555 C12.456,9.555 9.783,11.106 9.783,13.164 C9.783,13.716 10.23,14.164 10.783,14.164 C11.335,14.164 11.783,13.716 11.783,13.164 C11.783,12.864 12.238,12.436 13.043,12.096 L13.043,17.856 C11.668,16.365 9.705,15.425 7.521,15.425 C6.524,15.425 5.573,15.624 4.701,15.978 L7.061,10.473 L8.881,8.653 C8.982,8.552 9.06,8.431 9.11,8.297 L10.968,3.343 C11.586,2.918 12.395,2.885 13.043,3.242 L13.043,7.946 C13.043,8.498 13.491,8.946 14.043,8.946 C14.596,8.946 15.043,8.498 15.043,7.946 L15.043,2.729 C15.043,2.44 14.918,2.165 14.701,1.975 C13.211,0.675 10.963,0.675 9.473,1.975 C9.348,2.084 9.252,2.222 9.194,2.378 L7.313,7.392 L5.51,9.196 C5.42,9.285 5.348,9.392 5.298,9.509 L1.413,18.574 C0.527,19.808 0,21.315 0,22.946 C0,27.093 3.374,30.468 7.521,30.468 C11.669,30.468 15.043,27.093 15.043,22.946 L15.043,11.604 C15.345,11.573 15.663,11.555 16,11.555 C16.337,11.555 16.655,11.573 16.957,11.604 L16.957,22.946 C16.957,27.093 20.331,30.468 24.478,30.468 C28.625,30.468 32,27.093 32,22.946 C32,21.315 31.473,19.808 30.587,18.575 L26.702,9.509 Z",
    id: "path-f2f1d190-0dd2-40c3-a9a0-6bc2444fc67c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "24.9776902%",
    y1: "2.77878783%",
    x2: "51.784702%",
    y2: "105.141587%",
    id: "linearGradient-f2f1d190-0dd2-40c3-a9a0-6bc2444fc67c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Navigation-/-searchUsersLarge"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-f2f1d190-0dd2-40c3-a9a0-6bc2444fc67c",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-f2f1d190-0dd2-40c3-a9a0-6bc2444fc67c"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Icon-shape",
    fill: "currentColor",
    xlinkHref: "#path-f2f1d190-0dd2-40c3-a9a0-6bc2444fc67c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Icon-color",
    fill: "url(#linearGradient-f2f1d190-0dd2-40c3-a9a0-6bc2444fc67c)",
    mask: "url(#mask-f2f1d190-0dd2-40c3-a9a0-6bc2444fc67c)",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchUsersLarge);
export default __webpack_public_path__ + "static/media/searchUsersLarge.665fcc84348ff98675074a953924081a.svg";
export { ForwardRef as ReactComponent };